import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'
import { P, Text } from '@mxenabled/mxui'

import { useDebtStore, useGlobalCopyStore, useGoalStore } from '../../../common'
import { ExtraPaymentAction } from '../actions/ExtraPaymentAction'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

const PaydownContent = () => {
  const { debts: copy } = useGlobalCopyStore()
  const { totalMonthlyPayments } = useDebtStore()
  const { monthlyCashFlowProfile } = useGoalStore()

  const totalContributions = totalMonthlyPayments + Number(monthlyCashFlowProfile?.extra_payment)

  return (
    <Stack sx={{ backgroundColor: 'background.default', height: '100%' }}>
      <Stack p={24}>
        <Stack alignItems="center" gap={4} mb={24}>
          <Text variant="body1">{copy.paydown_drawer_mimimum_label}</Text>
          <P bold={true} variant="h1">
            {formatCurrency(totalMonthlyPayments, '0,0')}
          </P>
          <Text textAlign="center" truncate={false} variant="body2" width={208}>
            {copy.paydown_drawer_minimum_info}
          </Text>
        </Stack>
        <Stack>
          <Text variant="h3">{copy.paydown_drawer_subtitle}</Text>
          <Text truncate={false} variant="subtitle2">
            {copy.paydown_drawer_description}
          </Text>
        </Stack>
      </Stack>
      <Stack sx={{ backgroundColor: 'background.paper' }}>
        <ExtraPaymentAction />
      </Stack>
      <Stack flexDirection="row-reverse" px={24} py={12}>
        <Stack gap={4}>
          <Text variant="body2">{copy.paydown_drawer_total_payment}</Text>
          <Text bold={true} textAlign="right" variant="body1">
            {formatCurrency(totalContributions, '0,0')}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default observer(PaydownContent)
